import React from "react";
import classnames from "classnames";
import ResetState from "./resetstate";
import "./radio-buttons.scss";
import { Tooltip } from ".";
function RadioButtonInput({
  className,
  value,
  onChange,
  options = [],
  label = "",
  resetValue,
  isResetVisible = true,
  selectProps = {},
}) {
  const classes = classnames(
    "grigora-radio-buttons-input gap-[8px] text-grigora-base select-none items-center flex mb-2",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <span className="grigora-radio-buttons-input__label flex select-none  items-center">
          {label}
        </span>
      )}
      <div className="flex flex-1 flex-wrap items-center justify-center">
        <div className="flex gap-1 bg-gray-100 rounded-[5px] p-1">
          {options?.map(function (item, i) {
            return (
              <Tooltip
                placement="top"
                mouseEnterDelay={0.5}
                key={item.value}
                text={item.icon ? item.label : undefined}
              >
                <div
                  key={item.value}
                  onClick={(e) => {
                    onChange(item.value);
                  }}
                  className={`grigora-radio-buttons-input__button ${
                    value === item.value ? "active" : ""
                  }`}
                >
                  {item.icon ? item.icon : item.label}
                </div>
              </Tooltip>
            );
          })}
        </div>
      </div>
      <ResetState
        active={isResetVisible && value !== resetValue && value != ""}
        onClick={() => {
          onChange(resetValue);
        }}
      />
    </div>
  );
}

export default RadioButtonInput;
